<template>
    <GChart
            type="LineChart"
            :data="chartData"
            :options="chartOptions"
    />
</template>
<script>
    import { GChart } from 'vue-google-charts'
    export default {
        components: {
            GChart
        },
        data () {
            return {
                // Array will be automatically processed with visualization.arrayToDataTable function
                chartData: [
                    ['Gün', 'Harcama', 'Expenses', 'Profit'],
                    ['2014', 1000, 400, 200],
                    ['2015', 1170, 460, 250],
                    ['2016', 660, 1120, 300],
                    ['2017', 1030, 540, 350]
                ],
                chartOptions: {
                    chart: {
                        title: 'Company Performance',
                        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
                    }
                }
            }
        }
    }
</script>
<!--<script>-->
<!--import { Bar } from 'vue-chartjs'-->
<!--import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'-->

<!--export default {-->
<!--  extends: Bar,-->
<!--  mounted () {-->
<!--    // Overwriting base render method with actual data.-->
<!--    this.renderChart(-->
<!--      {-->
<!--        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],-->
<!--        datasets: [-->
<!--          {-->
<!--            label: 'GitHub Commits',-->
<!--            backgroundColor: '#f87979',-->
<!--            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      {-->
<!--        responsive: true,-->
<!--        maintainAspectRatio: true,-->
<!--        tooltips: {-->
<!--          enabled: false,-->
<!--          custom: CustomTooltips,-->
<!--          intersect: true,-->
<!--          mode: 'index',-->
<!--          position: 'nearest',-->
<!--          callbacks: {-->
<!--            labelColor: function (tooltipItem, chart) {-->
<!--              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    )-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<script>-->
<!--import { Line } from 'vue-chartjs'-->
<!--import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'-->
<!--import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'-->

<!--export default {-->
<!--  components: {-->
<!--    hexToRgba,-->
<!--    CustomTooltips-->
<!--  },-->
<!--  extends: Line,-->
<!--  mounted () {-->
<!--    this.renderChart(-->
<!--      {-->
<!--        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July','August','September','October','November','December'],-->
<!--        datasets: [-->
<!--          {-->
<!--            label: 'Data One',-->
<!--            backgroundColor: hexToRgba('#E46651', 90),-->
<!--            data: [30, 39, 10, 50, 30, 70, 35,20,40,50,30,70]-->
<!--          },-->
<!--          {-->
<!--            label: 'Data Two',-->
<!--            backgroundColor: hexToRgba('#00D8FF', 90),-->
<!--            data: [39, 80, 40, 35, 40, 20, 45,20,40,50,30,70]-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      {-->
<!--        responsive: true,-->
<!--        maintainAspectRatio: true,-->
<!--        tooltips: {-->
<!--          enabled: false,-->
<!--          custom: CustomTooltips,-->
<!--          intersect: true,-->
<!--          mode: 'index',-->
<!--          position: 'nearest',-->
<!--          callbacks: {-->
<!--            labelColor: function (tooltipItem, chart) {-->
<!--              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    )-->
<!--  }-->
<!--}-->
<!--</script>-->
